export enum DeliveryTypeEnum {
  CUSTOM = 'CUSTOM',
  CASINO = 'CASINO',
}
